import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchComingSoonListings, comingSoonSelector } from '../../../MarketplacePage/MarketplacePage.duck';
import { CarouselSection } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import { LISTING_SEARCH_ID } from '../../../../constants';

const ComingSoonSection = ({ sectionName, description }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const comingSoonListings = useSelector(comingSoonSelector);

  const handleClick = () => {
    history.push(
      createResourceLocatorString(
        'SearchPage',
        routeConfiguration,
        { searchId: LISTING_SEARCH_ID },
        { 'publicData.comingSoon': true }
      )
    );
  };

  useEffect(() => {
    dispatch(fetchComingSoonListings());
  }, []);

  return comingSoonListings?.length ? (
    <CarouselSection
      name={sectionName}
      description={description}
      items={comingSoonListings}
      handleAction={handleClick}
    />
  ) : null;
};

export default ComingSoonSection;
